import { Controller, useForm, type SubmitHandler } from "react-hook-form"
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import type { MunicipalitySharingLimitationFormInput } from "@/types"
import { useSetMunicipalityCanLimitSharing } from "@/hooks/api/use-municipality"

const MunicipalitySharingLimitationForm = ({
    municipalityId,
    municipalityCanLimitSharing,
    closeCallback,
} : {
    municipalityId: number,
    municipalityCanLimitSharing: boolean,
    closeCallback?: () => void,
}) => {

    const initialValues: MunicipalitySharingLimitationFormInput = {
        municipalityCanLimitSharing,
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        watch,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(() => reset(initialValues))

    const mutation = useSetMunicipalityCanLimitSharing(
        municipalityId,
        {
            setRequestInProgress,
            onSuccessCallback: closeCallback,
        },
    )

    const onSubmit: SubmitHandler<MunicipalitySharingLimitationFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    const newCanLimitSharing = watch('municipalityCanLimitSharing')

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={false}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText="Upravit"
            heading="Upravit možnost obce zvolit si sdílení její správy se svozovou společností"
            disableSave={municipalityCanLimitSharing === newCanLimitSharing}
        >
            <Box mx="auto" mb={1}>
                <FormControlLabel control={
                    <Controller
                        name="municipalityCanLimitSharing"
                        control={control}
                        render={({ field }) => <Switch
                            {...field}
                            value={!!field.value}
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />}
                    />
                } label="Obec může ve svém nastavení omezit sdílení sekce 'Správa obce' se svou svozovou společností" />
            </Box>
        </Form>
    )
}

export default MunicipalitySharingLimitationForm
